import api from '@/api';
import {
  PortoTaskListResponse,
  PortoTasksListRequest,
} from './porto-tasks.types';

const path = '/operational/v1/porto-tasks';

export default {
  async list(params?: PortoTasksListRequest) {
    const result = (await api.get(path, params)) as unknown;
    return result as PortoTaskListResponse;
  },
};
